import React from 'react';
import { processSteps } from '../mock';

export default function Process() {
  return (
    <section id="process" className="relative py-24 md:py-36 bg-[#0f0f10]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-px bg-[#e4cfaf]" />
          <span className="uppercase text-[11px] tracking-[0.28em] text-[#e4cfaf]/90">The Process</span>
        </div>
        <h2 className="serif text-white text-4xl md:text-6xl leading-[1.05] max-w-4xl">
          A simple three-step model that turns your property into <span className="italic-serif">hassle-free passive income.</span>
        </h2>

        <div className="mt-16 md:mt-24 grid md:grid-cols-3 gap-6 md:gap-8">
          {processSteps.map((s) => (
            <div key={s.num} className="tilt-card group relative border border-white/10 bg-[#141416] rounded-sm overflow-hidden">
              <div className="p-8 md:p-10">
                <div className="serif text-[#e4cfaf] text-5xl mb-6">{s.num}</div>
                <h3 className="serif text-white text-2xl md:text-3xl mb-4 leading-tight">{s.title}</h3>
                <p className="text-white/60 leading-relaxed text-[15px]">{s.body}</p>
              </div>
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
